import React, { useState, useEffect } from "react";

/**
 * DK : Navigacja do wybierania zakładek
 * @param items Tablica elementów do wybrania 
 * @param defaultItem Domyślnie wybrany item
 * @param onClick Funkcja wywołana po zmianie elementu (zwraca nazwe wybranego elementu)
 * @returns 
 */
const CustomNavItem = ({ items, defaultItem, onClick }) => {
    const [selectedItem, setSelectedItem] = useState(defaultItem)

    useEffect(() => {
        setSelectedItem(defaultItem)
    }, [defaultItem])

    const getStyle = (navItem) => {
        return navItem === selectedItem ? 'product-nav-item product-nav-item-selected' : 'product-nav-item';
    }
    const handleClick = (navItem) => {
        setSelectedItem(navItem);
        if (onClick) {
            onClick(navItem)
        }
    }

    return (
        <div className="product-nav">
            {items.map((item, key) => (
                <span
                    key={key}
                    className={getStyle(item)}
                    onClick={() => handleClick(item)}
                >
                    {item}
                </span>
            ))}
        </div>
    )
}

export default CustomNavItem